<div class="animated fadeIn">
  <div class="row">
    <div class="col-md-12 mb-4">
      <tabset>
        <tab heading="Collections" (selectTab)="onSelectCollectionsTab()">
          <app-collections-list-tab #collectionsTab></app-collections-list-tab>
        </tab>
        <tab heading="Periods" (selectTab)="onSelectPeriodsTab()">
          <app-collections-periods-tab #periodsTab></app-collections-periods-tab>
        </tab>
        <tab heading="Boosters" (selectTab)="onSelectBoostersTab()">
          <app-collections-boosters-tab #boostersTab></app-collections-boosters-tab>
        </tab>
      </tabset>
    </div>
  </div>
</div>
